"use client";

import { Navigate } from "react-router-dom";
import * as myApi from "../../Api";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const isAuthenticated = myApi.checkUserActive();
  const loginPath = myApi.loginPath;
  const dashboardPath = myApi.dashboardPath;
  const user = myApi.getUser();

  if (!isAuthenticated) {
    return <Navigate to={loginPath} replace />;
  }

  if (requireAdmin && user?.role !== "admin") {
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
